// import whatInput from 'what-input';
import cookies from './modules/cookies';
import lazyLoad from "./modules/lazy-load";
import navigation from "./modules/navigation.js";
import scroolTo from "./modules/scrool-to.js";
import slider from "./modules/slider.js";
import modal from "./modules/modal.js";
import openVideo from "./modules/open-video.js";
import {validation} from "./modules/validation";

const customScripts = (() => {
  const init = () => {
    lazyLoad.init();
    navigation.init();
    scroolTo.init();
    slider.init();
    // window.sliderMain = slider.sliderMain;
    modal.init();
    openVideo.init();
    validation.init();

    const cookiesClose = document.querySelector('[data-cookies-close]');

      if(cookiesClose)
        cookiesClose.addEventListener("click", (e) => onCookiesClose(e));
    };

    const onCookiesClose = (e) => {
        e.preventDefault();
        const button = e.target;
        const wrapper = button.closest('[data-cookies]');
        cookies.setCookie('cookies', true, 30);
        wrapper.classList.add("custom-hide");
    };

    return {
        init: init
    };
})();

document.addEventListener("DOMContentLoaded", customScripts.init);
